import { Backend, buildFormData } from '@/_axios';

export default {
  list(projectId, sampleSetId, params) {
    return Backend.get(`/project/${projectId}/sample_set/${sampleSetId}/samples/`, { params, cancelDuplicates: true });
  },
  createData(projectId, sampleSetId) {
    return Backend.get(`/project/${projectId}/sample_set/${sampleSetId}/samples/create`);
  },
  editData(projectId, sampleSetId, id) {
    return Backend.get(`/project/${projectId}/sample_set/${sampleSetId}/samples/${id}/edit`);
  },
  create(projectId, sampleSetId, data) {
    return Backend.post(`/project/${projectId}/sample_set/${sampleSetId}/samples/`, data);
  },
  upload(projectId, sampleSetId, data) {
    const formData = new FormData();
    buildFormData(formData, data);
    return Backend.post(
      `/project/${projectId}/sample_set/${sampleSetId}/samples/upload`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' }, noForbidden: true }
    );
  },
  update(projectId, sampleSetId, data) {
    return Backend.put(`/project/${projectId}/sample_set/${sampleSetId}/samples/${data.id}`, data);
  },
  delete(projectId, sampleSetId, id) {
    return Backend.delete(`/project/${projectId}/sample_set/${sampleSetId}/samples/${id}`);
  },
  fileExists(projectId, sampleSetId, hash) {
    return Backend.get(`/project/${projectId}/sample_set/${sampleSetId}/samples/exists/${hash}`);
  },
};
